// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import DynamicDropdownPresentationPropsDefault from "@insite/mobius/DynamicDropdown/presentationProps";
import IconCaretDown from "@plumberssupply/XDL/Icons/IconCaretDown";
import { xBaseTheme } from "@plumberssupply/XDL/types";
import { color } from "@plumberssupply/XDL/Utilities";
import styled, { css } from "styled-components";

export default {
    defaultProps: {
        ...DynamicDropdownPresentationPropsDefault,
        mergeCss: true,
        iconProps: {
            css: css`
                &&& {
                    padding: 0;
                    background: none;
                    top: 0;
                    right: 0;
                    width: 20px;
                    height: 35px;
                    color: ${color("common.ui9")};
                    svg {
                        height: 8px;
                        width: 8px;
                    }
                }
            `,
        },
        cssOverrides: {
            dropdownWrapper: css`
                &[aria-expanded="true"] > input:not(.react-datetime-picker__inputGroup__input) {
                    border: 1px solid ${color("common.ui2")};
                }
            `,
            formInputWrapper: css`
                margin-top: 6px;
                input:not(.react-datetime-picker__inputGroup__input):not([name="datetime"]) {
                    box-shadow: none;
                    &::placeholder {
                        color: ${color("text.main")};
                        font-style: normal;
                    }
                }
            `,
            list: css`
                border-color: ${color("common.ui2")};
                border-top-width: 0;
                top: 35px;
                width: 100%;
                border-radius: 0 0 2px 2px;
                background-color: ${color("common.white")};
                box-shadow: inset 0 1px 0 0 ${color("common.ui10", 0.1)};
            `,
        },
    },
} as xBaseTheme["dynamicDropdown"];
